/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_TitleInputs */

const en_agents_title = /** @type {(inputs: Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents & API`)
};

/**
* | output |
* | --- |
* | "Agents & API" |
*
* @param {Agents_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const agents_title = /** @type {((inputs?: Agents_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_agents_title(inputs)
});